import { render, staticRenderFns } from "./JtDataGridSubtitle.vue?vue&type=template&id=29e81050&scoped=true"
import script from "./JtDataGridSubtitle.vue?vue&type=script&lang=js"
export * from "./JtDataGridSubtitle.vue?vue&type=script&lang=js"
import style0 from "./JtDataGridSubtitle.vue?vue&type=style&index=0&id=29e81050&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e81050",
  null
  
)

export default component.exports